import { QueryStringKeys } from '@/constants/commons'
import { isEmpty as _isEmpty } from 'lodash-es'
import { SearchType, type SearchRecordItem } from '@/types/search'

type HandleSearchOpts = {
  otherQuery?: Record<string, any>
}

export function useSearchInput() {
  const route = useRoute()
  const router = useLocaleRouter()
  const { t } = useI18n()
  const { regionId, regionName } = useRegion()
  const { tagId, categoryId, categoryName } = useCategory()
  const searchRecord = useSearchRecord()
  const searchRecordKey = computed(() => tagId.value ?? categoryId.value)

  const querySearchKeyword = computed(() => route.query[QueryStringKeys.SEARCH_KEYWORD] as string)

  const searchKeyword = ref(querySearchKeyword.value ?? '')

  const searchInputPlaceholder = computed(() => {
    const i18nKey = categoryName.value ? 'search.placeholder.category' : 'search.placeholder.home'

    return t(i18nKey, { region_name: regionName.value, category_name: categoryName.value })
  })

  watch(querySearchKeyword, newQuerySearchKeyword => {
    if (searchKeyword.value !== newQuerySearchKeyword) {
      searchKeyword.value = newQuerySearchKeyword
    }
  })

  function handleSearch(item: SearchRecordItem, opts: HandleSearchOpts = {}) {
    if (_isEmpty(item)) return
    const { otherQuery } = opts
    const nextQueries = { ...cloneDeep(route.query), ...otherQuery }

    if (item.text) {
      searchRecord.add(item, searchRecordKey.value)
    }

    switch (item.type) {
      case SearchType.KEYWORD: {
        if (item.text) {
          nextQueries[QueryStringKeys.SEARCH_KEYWORD] = item.text
        } else {
          delete nextQueries[QueryStringKeys.SEARCH_KEYWORD]
        }
        delete nextQueries[QueryStringKeys.SUGGESTION_CONTEXT]
        break
      }
      case SearchType.TAG: {
        nextQueries[QueryStringKeys.SUGGESTION_CONTEXT] = item.context
        nextQueries[QueryStringKeys.SEARCH_KEYWORD] = item.text
        break
      }
    }
    delete nextQueries[QueryStringKeys.LIST_PAGE]

    // 如果是點選店家 直接到店家頁面
    if (item.type === SearchType.BRANCH) {
      router.push({ path: `/branches/${item.identity}` })
      return
    }
    // 判斷目前在哪個頁面的搜尋網址
    let regionSearchSubPath = `/regions/${regionId.value}/search`
    if (route.params.cid) {
      regionSearchSubPath = `/regions/${regionId.value}/categories/${route.params.cid}`
    } else if (route.params.tid) {
      regionSearchSubPath = `/regions/${regionId.value}/themes/${route.params.tid}`
    } else if (tagId.value) {
      regionSearchSubPath = `/regions/${regionId.value}/tags/${tagId.value}`
    }

    router.push({ path: regionSearchSubPath, query: trimObject(nextQueries) })
  }

  return { searchKeyword, searchInputPlaceholder, handleSearch }
}
